// @ts-nocheck
import React from 'react';
import { Grid, TextField, Typography, FormControlLabel, Switch } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

function NoReenterForm({ automation, onAutomationChange, error, products = {}, classes }) {
  const { t } = useTranslation();
  const productOptions = Object.values(products);
  const currentProduct = products[automation.productId];

  const handleToggle = (e) => {
    onAutomationChange({
      ...automation,
      noReEntered: e.target.checked,
      productId: e.target.checked ? automation.productId : null,
    });
  };

  return (
    <>
      <FormControlLabel
        classes={{ root: classes.switchContainer, label: classes.switchLabel }}
        labelPlacement="start"
        control={<Switch checked={automation.noReEntered} onChange={handleToggle} name="noReEntered" />}
        label={t('processTypes.modal_automation.option_no_reenter')}
      />

      {automation.noReEntered && (
        <Grid container classes={{ root: classes.formGrid }} spacing={2}>
          {error && (
            <Grid item xs={12}>
              <Typography color="error" variant="caption">{error}</Typography>
            </Grid>
          )}

          <Grid item xs={12}>
            <Autocomplete
              options={productOptions}
              getOptionLabel={(o) => (o?.name ? `[${o.code}] — ${o.name}` : '')}
              value={currentProduct || null}
              onChange={(_, val) => onAutomationChange({ ...automation, productId: val?.id || null })}
              renderInput={(params) => <TextField {...params} label={t('Seleccionar Producto')} />}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              disabled
              fullWidth
              label={t('processTypes.modal_automation.reenter_form_placeholders.specie')}
              value={currentProduct?.Variety?.Fruit?.name || ""}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              disabled
              fullWidth
              label={t('processTypes.modal_automation.reenter_form_placeholders.variety')}
              value={currentProduct?.Variety?.name || ""}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default NoReenterForm;
